/**
 * The attributes every {@link WebGL2RenderingContext} the viewer renders
 * through is created with.
 *
 * `antialias` is off because the viewer composites its own multi-sampled
 * framebuffers, and `stencil` is required: contour clipping renders through
 * the stencil buffer, and a context granted without one draws silently
 * wrong instead of failing.
 *
 * A context probed with different attributes says nothing about the context
 * the viewer will get, so support checks and the viewer itself share this
 * one definition.
 */
export const RENDERING_CONTEXT_ATTRIBUTES: WebGLContextAttributes = {
    antialias: false,
    stencil: true,
};
